import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss']
})
export class ChipsComponent implements OnInit {

  @Input() placeholder = 'Search';

  items: string[] = [];

  constructor() { }

  find(term: string) {

  }

  add(term: string) {
    this.items.push(term);
  }

  delete(term: string) {
    this.items = this.items.filter(i => i !== term);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/chips/chips.component.ts